import React, { useState } from 'react'

import ImgWithFallback from 'components/common/ImgWithFallback/ImgWithFallback'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useStyles from './styles'

const Image = ({ alt, thumb, src }) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const classes = useStyles({ isLoaded })
    return (
        <>
            <ImgWithFallback className={clsx(classes.image, classes.thumb)} alt={alt} src={thumb} />
            <ImgWithFallback
                onLoad={() => {
                    setIsLoaded(true)
                }}
                className={clsx(classes.image, classes.full)}
                alt={alt}
                src={src}
            />
        </>
    )
}

Image.propTypes = {
    alt: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
}

export default Image
